export var LoadStatus;
(function (LoadStatus) {
    LoadStatus[LoadStatus["Active"] = 0] = "Active";
    LoadStatus[LoadStatus["Finished"] = 1] = "Finished";
    LoadStatus[LoadStatus["Removed"] = 2] = "Removed";
    LoadStatus[LoadStatus["SentToDriver"] = 3] = "SentToDriver";
    LoadStatus[LoadStatus["Accepted"] = 4] = "Accepted";
    LoadStatus[LoadStatus["Declined"] = 5] = "Declined";
})(LoadStatus || (LoadStatus = {}));
export var TimeVar;
(function (TimeVar) {
    TimeVar[TimeVar["Exact"] = 0] = "Exact";
    TimeVar[TimeVar["FCFS"] = 1] = "FCFS";
    TimeVar[TimeVar["All"] = 2] = "All";
})(TimeVar || (TimeVar = {}));
export function WhatTime(time) {
    switch (time) {
        case TimeVar.All: return "24/7";
        case TimeVar.Exact: return "Exact date and time";
        case TimeVar.FCFS: return "FCFS";
        default: return "Some kind of time";
    }
}
